import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Item do Recebimento", -1)
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-17 ant-col-xl-17" }, null, -1)
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "ss-movimento-comercial-cabecalho-fixo" }
const _hoisted_10 = {
  class: "ant-row ss-movimento-comercial-totalizador ss-sombra-suave",
  style: {"margin-bottom":"10px"}
}
const _hoisted_11 = { class: "ant-col ant-col-xs-21 ant-col-xl-21" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-12 ant-col-xl-4 ss-movimento-comercial-campo-totalizador" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Total do Produto", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Desconto", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "ant-col ant-col-xs-12 ant-col-xl-4 ss-movimento-comercial-campo-totalizador" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Impostos", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "ant-col ant-col-xs-12 ant-col-xl-4 ss-movimento-comercial-campo-totalizador" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Total do Pedido", -1)
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-3",
  style: {"background-color":"#40a9ff"}
}
const _hoisted_26 = { class: "ant-row" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-movimento-comercial-campo-totalizador" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"white","font-weight":"bolder"} }, "Total do Item", -1)
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  class: "ant-row",
  style: {"height":"100%"}
}
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_32 = { class: "ant-row" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_34 = { class: "ant-row" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_36 = { class: "ant-col ant-col-xs-12 ant-col-xl-2" }
const _hoisted_37 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_38 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_39 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_40 = { class: "ant-row" }
const _hoisted_41 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_42 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_43 = { class: "ant-row" }
const _hoisted_44 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_45 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "100%",
    centered: "",
    "wrap-class-name": _ctx.state.telaMobile ? 'full-modal ss-modal-compras' : 'scroll-modal ss-modal-compras'
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_tooltip, {
            placement: "top",
            title: "Item Anterior"
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                disabled: !_ctx.props.existeAnterior || _ctx.state.item.codigo === undefined,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.itemAnterior && _ctx.itemAnterior(...args)))
              }, [
                _createVNode(_component_icone, { nome: "navegacao-anterior" })
              ], 8, _hoisted_5)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tooltip, {
            placement: "top",
            title: "Próximo Item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                disabled: !_ctx.props.existeProximo || _ctx.state.item.codigo === undefined,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.proximoItem && _ctx.proximoItem(...args)))
              }, [
                _createVNode(_component_icone, { nome: "navegacao-proximo" })
              ], 8, _hoisted_6)
            ]),
            _: 1
          }),
          (_ctx.props.editavel)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
              }, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 10 }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.valorUnitario * _ctx.state.item.quantidade, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_15)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.desconto, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_18)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.imposto.valorTotalTributos, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_21)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.totalNota, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_24)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      style: {"background-color":"#40a9ff","color":"white","font-weight":"bolder"},
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.item.valorTotal, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_29)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_a_form, { layout: "vertical" }, {
                default: _withCtx(() => [
                  _createVNode(_component_card, { class: "ss-card" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_a_form_item, {
                            label: "Produto",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_produto, {
                                apresentarCodigoInterno: true,
                                modoDefinicaoProduto: true,
                                limparSelecao: false,
                                empresas: [_ctx.props.empresa],
                                codigoSelecionado: _ctx.state.item.codigoProdutoDefinicao,
                                "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.item.codigoProdutoDefinicao) = $event)),
                                disabled: !_ctx.props.editavel
                              }, null, 8, ["empresas", "codigoSelecionado", "disabled"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_a_form_item, {
                            label: "Unidade",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_unidade_produto_movimento, {
                                apenasUnidadePrincipal: true,
                                codigoProdutoDefinicao: _ctx.state.item.codigoProdutoDefinicao,
                                codigoUnidadeSelecionada: _ctx.state.item.unidade,
                                "onUpdate:codigoUnidadeSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.item.unidade) = $event)),
                                descricao: _ctx.state.item.descricaoUnidade,
                                "onUpdate:descricao": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.item.descricaoUnidade) = $event)),
                                sigla: _ctx.state.item.siglaUnidade,
                                "onUpdate:sigla": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.item.siglaUnidade) = $event)),
                                casasDecimais: 2,
                                fatorConversao: 1,
                                disabled: !_ctx.editavel
                              }, null, 8, ["codigoProdutoDefinicao", "codigoUnidadeSelecionada", "descricao", "sigla", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_a_form_item, {
                            label: "Quantidade",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              ((_ctx.state.item.unidade > 0))
                                ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                    key: 0,
                                    quantidadeCasasDecimais: 2,
                                    fracionar: true,
                                    valor: _ctx.state.item.quantidade,
                                    "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.item.quantidade) = $event)),
                                    disabled: !_ctx.editavel
                                  }, null, 8, ["valor", "disabled"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(_component_a_form_item, {
                            label: "Valor Unitário",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 2,
                                monetario: true,
                                valor: _ctx.state.item.valorUnitario,
                                "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.item.valorUnitario) = $event)),
                                disabled: !_ctx.editavel,
                                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.calculaTotalItemEAtualizaTotalNota()))
                              }, null, 8, ["valor", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_a_form_item, {
                            label: "Desconto",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 2,
                                monetario: true,
                                valor: _ctx.state.item.desconto,
                                "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.item.desconto) = $event)),
                                disabled: !_ctx.editavel,
                                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.calculaTotalItemEAtualizaTotalNota()))
                              }, null, 8, ["valor", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_a_form_item, {
                            label: "Valor total do item",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                quantidadeCasasDecimais: 2,
                                monetario: true,
                                valor: _ctx.state.item.valorTotal,
                                "onUpdate:valor": [
                                  _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.item.valorTotal) = $event)),
                                  _ctx.calcularTotalNota
                                ],
                                disabled: true
                              }, null, 8, ["valor", "onUpdate:valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tabs, {
                    class: "ss-card",
                    defaultActiveKey: "1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tab_pane, {
                        key: "1",
                        tab: "IMPOSTOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form, { layout: "vertical" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_tabs, {
                                    class: "ss-card",
                                    defaultActiveKey: "1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_tab_pane, {
                                        key: "1",
                                        tab: "ICMS"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_card, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_40, [
                                                _createElementVNode("div", _hoisted_41, [
                                                  _createVNode(_component_a_form_item, {
                                                    label: "Alíquota do ICMS",
                                                    class: "ss-margin-campos"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_campo_numerico, {
                                                        percentual: true,
                                                        quantidadeCasasDecimais: 2,
                                                        valor: _ctx.state.item.imposto.aliquotaIcms,
                                                        "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.item.imposto.aliquotaIcms) = $event)),
                                                        disabled: !_ctx.props.editavel,
                                                        onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.calcularTributacoes()))
                                                      }, null, 8, ["valor", "disabled"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_42, [
                                                  _createVNode(_component_a_form_item, {
                                                    label: "Valor do ICMS",
                                                    class: "ss-margin-campos"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_campo_numerico, {
                                                        monetario: true,
                                                        quantidadeCasasDecimais: 2,
                                                        valor: _ctx.state.item.imposto.valorIcms,
                                                        "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.item.imposto.valorIcms) = $event)),
                                                        disabled: !_ctx.props.editavel
                                                      }, null, 8, ["valor", "disabled"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_tab_pane, {
                                        key: "2",
                                        tab: "IPI"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_card, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_43, [
                                                _createElementVNode("div", _hoisted_44, [
                                                  _createVNode(_component_a_form_item, {
                                                    label: "Alíquota do IPI",
                                                    class: "ss-margin-campos"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_campo_numerico, {
                                                        percentual: true,
                                                        quantidadeCasasDecimais: 2,
                                                        valor: _ctx.state.item.imposto.aliquotaIpi,
                                                        "onUpdate:valor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.item.imposto.aliquotaIpi) = $event)),
                                                        disabled: !_ctx.props.editavel,
                                                        onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.calcularTributacoes()))
                                                      }, null, 8, ["valor", "disabled"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_45, [
                                                  _createVNode(_component_a_form_item, {
                                                    label: "Valor do IPI",
                                                    class: "ss-margin-campos"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_campo_numerico, {
                                                        monetario: true,
                                                        quantidadeCasasDecimais: 2,
                                                        valor: _ctx.state.item.imposto.valorIpi,
                                                        "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.item.imposto.valorIpi) = $event)),
                                                        disabled: !_ctx.props.editavel
                                                      }, null, 8, ["valor", "disabled"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}